import React from 'react';
import TaskMasterScreenview from './TaskMasterScreenview';
import AddModal from './AddModal';

const TaskMasterView = () => {
    return (
        <>
            <TaskMasterScreenview />
            <AddModal />
        </>
    );
};

export default TaskMasterView;
